
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faClone } from '@fortawesome/free-solid-svg-icons'
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';

function CopyCard({ trade_id, image, photo1, name, winrate, profit, win, loss, copy, price, badge_color, trades, description, username, followers }) {
    const { user } = useUser();
    const [modalIsOpen, setIsOpen] = useState(false);
    const [copied, setCopied] = useState(copy);
    const [loading, setLoading] = useState(false);
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    const ValidateCopy = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/copytrade.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_copy: true, trade_id: trade_id, price: price, copied : !copied })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            setLoading(false);
            toast.success(data.result);
            setCopied(!copied);
          }else{
            toast.error(data.message);
          }
        })
        .catch(err => {
          console.error(err)
          setLoading(false);
          toast.error('There was an issue processing your deposit.')
        })
    }
    return (
      <>
      <div className="mycard mb-4">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center" style={{gap:'10px'}}>
            <div className="rounded-3 d-flex align-items-center justify-content-center overflow-hidden" style={{width:'52px',height:'52px',minWidth:'52px',minHeight:'52px'}}>
              {image}
            </div>
            <div>
              <div className="d-flex align-items-center">
                <p className="text-white fw-bold mb-0" style={{fontSize: '16px'}}>{name}</p>
                <div className="position-relative rounded-circle ms-2" style={{backgroundColor: 'white', height:'13px',width:'13px'}}>
                  <img src={`/uploads/${badge_color === "gold" ? "goldtick.png" : "bluetick.png"}`} alt="badge" width="18px" className="position-absolute" style={{left: '-2px',top:'-3px'}} />
                </div>
                <img src={`/uploads/${photo1}`} height="20px" className="ms-3" alt="icon" />
              </div>
              <p className="mb-0 text-secondary lh-1" style={{fontSize:'12px'}}>@{username}</p>
              <div className="d-flex align-items-center">
                <FontAwesomeIcon icon={faClone} className={`me-2 ${copied?'text-prime':'text-secondary'}`} style={{fontSize: '12px'}} />
                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}><span className="fw-bold text-white">{followers}</span> followers</p>
              </div>
            </div>
          </div>
        </div>
        <p className="mt-3 text-secondary" style={{fontSize:'14px',lineHeight:'120%'}}>{description}</p>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'13px'}}>Win Rate</p>
            <p className="mb-0 text-success fw-bold" style={{fontSize:'14px'}}>{winrate}%</p>
          </div>
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'13px'}}>Profit Share</p>
            <p className="mb-0 text-success fw-bold" style={{fontSize:'14px'}}>{profit}%</p>
          </div>
          <div className="text-end">
            <p className="mb-0 text-secondary" style={{fontSize:'13px'}}>Wins</p>
            <p className="mb-0 fw-bold" style={{fontSize:'14px'}}>{win}</p>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'13px'}}>Losses</p>
            <p className="mb-0 fw-bold" style={{fontSize:'14px'}}>{loss}</p>
          </div>
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'13px'}}>Trades</p>
            <p className="mb-0 fw-bold" style={{fontSize:'14px'}}>{trades}</p>
          </div>
          <div className="text-end">
            <p className="mb-0 text-secondary" style={{fontSize:'13px'}}>Price</p>
            <p className="mb-0 text-success fw-bold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate)}</p>
          </div>
        </div>
        <div className="d-flex align-items-center mt-4" style={{gap:'10px'}}>
          <div className={`myBtn ${copied?'bg-danger':'bg-prime'} w-100 text-center`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={ValidateCopy}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:copied? 'Cancel':'Copy Expert'}</div>
        </div>
      </div>
      </>
    )
  }
  
  export default CopyCard